export default __webpack_public_path__ + "static/media/AssociateMono-Light.729e68bf.woff";